import PropTypes from 'prop-types'
import Lottie from 'react-lottie'
import * as animationData from './data.json'

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData.default,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

const Person = ({ width, height }) => {
  return (
    <Lottie
      options={defaultOptions}
      isClickToPauseDisabled
      width={width}
      height={height}
    />
  )
}

Person.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

export default Person
